var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { createContext, useContext, useEffect, useMemo, useRef, useState, } from 'react';
import { GroupEquipmentStatus } from '@tenderd/schema';
import { SplashScreen, useAuth, useMixpanel, useService } from '@tenderd/track-web-utils';
import { useDebounce } from 'use-debounce';
import { GroupTrackingPageTKeys } from '../translations/keys';
import { i18n } from '../translations';
import { getStatusLabel } from '../pages/GroupAnalyticsPage/GroupAnalyticsPage';
import { MachineFilterEvents } from "../constants/AnalyticsEvents";
var MachineViewContext = createContext({
    storedFilters: null,
    setStoredFilters: function (v) { },
    tagFilters: {
        capacityChecked: true,
        manualStatusChecked: false,
        autoStatusChecked: true,
        ignitionChecked: true,
        operatorChecked: false,
        speedChecked: true,
        fuelChecked: false,
        odometerChecked: false,
        hourmeterChecked: false,
        customIdChecked: false,
        weightChecked: false,
        numberPlateChecked: true,
    },
    setTagFilters: function () { },
    categoryChecklist: [],
    setCategoryChecklist: function () { },
    statusChecklist: [],
    setStatusChecklist: function () { },
    queryDebounce: '',
    querySearch: '',
    setQuery: function () { },
    categoryList: [],
    setCategoryList: function () { },
    categoryListTemp: [],
    setCategoryListTemp: function () { },
    statusList: [],
    setStatusList: function () { },
    contractorList: [],
    setContractorList: function () { },
    contractorCheckList: [],
    setContractorCheckList: function () { },
    updateStoredFilters: function () { },
    resetAllFilters: function () { },
    filtersCount: 0,
});
export var useMachineViewOptions = function () { return useContext(MachineViewContext); };
export var MachineViewOptionsProvider = function (_a) {
    var _b;
    var children = _a.children;
    var _c = __read(useState({
        capacityChecked: true,
        manualStatusChecked: false,
        autoStatusChecked: true,
        ignitionChecked: true,
        operatorChecked: false,
        speedChecked: true,
        fuelChecked: false,
        contractorChecked: false,
        odometerChecked: false,
        hourmeterChecked: false,
        customIdChecked: false,
        weightChecked: false,
        numberPlateChecked: true,
    }), 2), tagFilters = _c[0], setTagFilters = _c[1];
    var _d = __read(useState(true), 2), loading = _d[0], setLoading = _d[1];
    var _e = __read(useState([]), 2), categoryChecklist = _e[0], setCategoryChecklist = _e[1];
    var _f = __read(useState([]), 2), statusChecklist = _f[0], setStatusChecklist = _f[1];
    var _g = __read(useState([]), 2), contractorList = _g[0], setContractorList = _g[1];
    var _h = __read(useState([]), 2), contractorCheckList = _h[0], setContractorCheckList = _h[1];
    var storedFiltersRef = useRef({
        tagFilters: {
            capacityChecked: true,
            manualStatusChecked: false,
            autoStatusChecked: true,
            ignitionChecked: true,
            operatorChecked: false,
            speedChecked: true,
            fuelChecked: false,
            odometerChecked: false,
            hourmeterChecked: false,
            customIdChecked: false,
            weightChecked: false,
            numberPlateChecked: true,
        },
        equipmentIds: [],
        categoryChecklist: [],
        statusChecklist: [],
        contractors: [],
    });
    var _j = __read(useState(''), 2), querySearch = _j[0], setQuery = _j[1];
    var _k = __read(useDebounce(querySearch, 1000), 1), queryDebounce = _k[0];
    var mixpanel = useMixpanel();
    var account = useAuth().account;
    var service = useService();
    var _l = __read(useState([]), 2), categoryList = _l[0], setCategoryList = _l[1];
    var _m = __read(useState([]), 2), categoryListTemp = _m[0], setCategoryListTemp = _m[1];
    var _o = __read(useState([]), 2), statusList = _o[0], setStatusList = _o[1];
    useEffect(function () {
        if (queryDebounce !== "")
            mixpanel.track(MachineFilterEvents.SearchedForMachine, {
                equipmentName: queryDebounce,
                extension: 'track',
            });
    }, [queryDebounce]);
    var getFilters = function () { return __awaiter(void 0, void 0, void 0, function () {
        var equipment_status, statusList, catList, defaultStatusValueList, contractorsRes;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    equipment_status = Object.values(GroupEquipmentStatus);
                    statusList = getLabelValueArray(equipment_status);
                    catList = [];
                    return [4 /*yield*/, service.server
                            .getEquipmentTypesOfAccount(account.id)
                            .then(function (data) {
                            catList = data.map(function (el) { return ({
                                label: getStatusLabel(el),
                                value: el,
                            }); });
                            setCategoryListTemp(data);
                        })];
                case 1:
                    _f.sent();
                    defaultStatusValueList = statusList.filter(function (item) {
                        return item.value !== 'demobilised' &&
                            item.value !== 'demobilised - replacement' &&
                            item.value !== 'cancelled';
                    });
                    setCategoryList(catList);
                    setStatusList(statusList);
                    setCategoryChecklist(((_a = storedFiltersRef.current.categoryChecklist) === null || _a === void 0 ? void 0 : _a.length)
                        ? storedFiltersRef.current.categoryChecklist
                        : catList.map(function (a) { return a.value; }));
                    setStatusChecklist(((_b = storedFiltersRef.current.statusChecklist) === null || _b === void 0 ? void 0 : _b.length)
                        ? storedFiltersRef.current.statusChecklist
                        : defaultStatusValueList.map(function (a) { return a.value; }));
                    setTagFilters(storedFiltersRef.current.tagFilters
                        ? storedFiltersRef.current.tagFilters
                        : __assign({ capacityChecked: true, manualStatusChecked: false, autoStatusChecked: true, ignitionChecked: true, operatorChecked: false, speedChecked: true, fuelChecked: false, odometerChecked: false, hourmeterChecked: false, customIdChecked: false, weightChecked: false, numberPlateChecked: true }, (((_c = account.doc.feature_flags) === null || _c === void 0 ? void 0 : _c.compartment_temperature)
                            ? { compartmentTemperature: false }
                            : {})));
                    return [4 /*yield*/, service.server.getContractorsOfAccount(account.id)];
                case 2:
                    contractorsRes = _f.sent();
                    setContractorList(contractorsRes);
                    if ((_e = (_d = storedFiltersRef.current) === null || _d === void 0 ? void 0 : _d.contractors) === null || _e === void 0 ? void 0 : _e.length) {
                        setContractorCheckList(contractorsRes.filter(function (con) { var _a; return (_a = storedFiltersRef.current) === null || _a === void 0 ? void 0 : _a.contractors.includes(con.id); }));
                    }
                    else {
                        setContractorCheckList([]);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var getStoredFilters = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setLoading(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, service.server.getFilters()];
                case 2:
                    res = _d.sent();
                    if (((_a = res.categoryChecklist) === null || _a === void 0 ? void 0 : _a.length) &&
                        res.categoryChecklist[0].name) {
                        res.categoryChecklist = res.categoryChecklist.map(function (e) { return e.name; });
                    }
                    storedFiltersRef.current = res;
                    if (Object.keys(res === null || res === void 0 ? void 0 : res.tagFilters).length) {
                        setTagFilters(res.tagFilters);
                    }
                    if ((_b = res === null || res === void 0 ? void 0 : res.categoryChecklist) === null || _b === void 0 ? void 0 : _b.length) {
                        setCategoryChecklist(res.categoryChecklist);
                    }
                    if ((_c = res === null || res === void 0 ? void 0 : res.statusChecklist) === null || _c === void 0 ? void 0 : _c.length) {
                        setStatusChecklist(res.statusChecklist);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _d.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, getStoredFilters()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getFilters()];
                case 2:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getData();
    }, []);
    var setStoredFilters = function (v) {
        storedFiltersRef.current = v;
    };
    var GroupEquipmentStatusMap = (_b = {},
        _b[GroupEquipmentStatus.Working] = i18n.t(GroupTrackingPageTKeys.working),
        _b[GroupEquipmentStatus.Unassigned] = i18n.t(GroupTrackingPageTKeys.idle),
        _b[GroupEquipmentStatus.Removed] = i18n.t(GroupTrackingPageTKeys.demobilised),
        _b[GroupEquipmentStatus.Breakdown] = i18n.t(GroupTrackingPageTKeys.underRepair),
        _b);
    var resetStoredFilters = function () {
        var updatedFilters = {
            tagFilters: {
                autoStatusChecked: true,
                capacityChecked: true,
                speedChecked: true,
                ignitionChecked: true,
                numberPlateChecked: true,
            },
            categoryChecklist: categoryListTemp,
            statusChecklist: statusList.map(function (status) { return status.value; }),
        };
        setStoredFilters(updatedFilters);
        service.server
            .setFilters(updatedFilters)
            .then(function () { })
            .catch(function (e) { });
    };
    var resetAllFilters = function () {
        resetStoredFilters();
        setTagFilters({
            autoStatusChecked: true,
            capacityChecked: true,
            speedChecked: true,
            ignitionChecked: true,
            numberPlateChecked: true,
        });
        setCategoryChecklist(categoryListTemp);
        setStatusChecklist(statusList.map(function (status) { return status.value; }));
        setContractorCheckList([]);
        setContractorList(contractorList);
        setQuery('');
        mixpanel.track('Reset Filters', { extension: 'track' });
    };
    var getLabelValueArray = function (arr) {
        var list = Object.values(arr.map(function (key) {
            if (key === 'demobilised - replacement') {
                key = 'demobilised';
            }
            return {
                label: GroupEquipmentStatusMap[getStatusLabel(key)]
                    ? GroupEquipmentStatusMap[getStatusLabel(key)]
                    : getStatusLabel(key),
                value: key,
            };
        }));
        list = list.filter(function (v, i, a) {
            return a.findIndex(function (t) { return t.label === v.label && t.value === v.value; }) === i;
        });
        return list;
    };
    var updateStoredFilters = function (key, value) {
        var _a;
        var updatedFilters = __assign(__assign({}, storedFiltersRef.current), (_a = {}, _a[key] = value, _a));
        storedFiltersRef.current = updatedFilters;
        service.server
            .setFilters(updatedFilters)
            .then(function () { })
            .catch(function (e) { });
    };
    var filtersCount = useMemo(function () {
        var count = 0;
        if (categoryChecklist.length < categoryList.length) {
            count += categoryList.length - categoryChecklist.length;
        }
        if (statusChecklist.length < statusList.length) {
            count += statusList.length - statusChecklist.length;
        }
        count += contractorList.filter(function (con) {
            return contractorCheckList.map(function (li) { return li.id; }).includes(con.id);
        }).length;
        return count;
    }, [
        categoryChecklist,
        statusChecklist,
        contractorCheckList,
        contractorList,
        categoryList,
        statusList,
    ]);
    return (React.createElement(MachineViewContext.Provider, { value: {
            tagFilters: tagFilters,
            setTagFilters: setTagFilters,
            categoryChecklist: categoryChecklist,
            setCategoryChecklist: setCategoryChecklist,
            statusChecklist: statusChecklist,
            setStatusChecklist: setStatusChecklist,
            storedFilters: storedFiltersRef.current,
            setStoredFilters: setStoredFilters,
            queryDebounce: queryDebounce,
            querySearch: querySearch,
            setQuery: setQuery,
            updateStoredFilters: updateStoredFilters,
            categoryList: categoryList,
            setCategoryList: setCategoryList,
            categoryListTemp: categoryListTemp,
            setCategoryListTemp: setCategoryListTemp,
            statusList: statusList,
            setStatusList: setStatusList,
            contractorList: contractorList,
            setContractorList: setContractorList,
            contractorCheckList: contractorCheckList,
            setContractorCheckList: setContractorCheckList,
            resetAllFilters: resetAllFilters,
            filtersCount: filtersCount,
        } }, loading ? React.createElement(SplashScreen, null) : children));
};
